import { NumberInput, TextInput } from "react-admin";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";

const sizeFilterList = [
  // <TextInput
  //   source="all"
  //   label="mine.filter.search_all"
  //   variant="outlined"
  //   alwaysOn
  //   resettable
  //   InputProps={{
  //     endAdornment: (
  //       <InputAdornment position="end">
  //         <SearchIcon />
  //       </InputAdornment>
  //     ),
  //   }}
  // />,
  <TextInput
    source="name"
    label="mine.label.name"
    variant="outlined"
    alwaysOn
    resettable
  />,
  <NumberInput
    source="code"
    label="mine.label.code"
    variant="outlined"
    resettable
    alwaysOn
  />,
  <NumberInput source="d1" variant="outlined" resettable alwaysOn />,
  <NumberInput source="d2" variant="outlined" resettable alwaysOn />,
  // <BooleanInput source="active" resettable alwaysOn />,
];

export default sizeFilterList;
